/** US-405: hours-based ROI (no fake currency). */
export const PLATFORM_HOURS_PER_CASE_DEFAULT = 0.75;

export function hoursSavedPerMonth(
  casesPerMonth: number,
  manualHoursPerCase: number,
  platformHoursPerCase: number = PLATFORM_HOURS_PER_CASE_DEFAULT
): number {
  const cases = Math.max(0, casesPerMonth);
  const manual = Math.max(0, manualHoursPerCase);
  const platform = Math.max(0, platformHoursPerCase);
  return Math.max(0, cases * (manual - platform));
}
